type KlarnaPaymentMethodCategory = {
  identifier: string;
};

type KlarnaWalletPaymentSession = {
  client_token: string;
  payment_method_categories: KlarnaPaymentMethodCategory[];
  session_id: string;
};

const fetchKlarnaSessionData = async (url: string, params: FormData) => {
  const response = await fetch(url, {
    method: 'POST',
    headers: { Accept: 'application/json' },
    body: params,
  });

  return await response.json();
};

const getSession = async (walletCode: string): Promise<KlarnaWalletPaymentSession> => {
  const params = new FormData();
  params.append('walletProvider', walletCode);

  const { model } = await fetchKlarnaSessionData(
    '/rpc.responsive.air.payment.getwalletpaymentsession.do.action',
    params,
  );

  return JSON.parse(model);
};

export const initSession = async (code: string) => {
  const response = await getSession(code);

  return {
    clientToken: response ? response.client_token : null,
    availableCategories: (response ? response.payment_method_categories : []).map(
      (category) => category.identifier,
    ),
    sessionId: response ? response.session_id : null,
  };
};

export const updateSession = async (sessionId: string, walletCode: string) => {
  const params = new FormData();
  params.append('walletProvider', 'Klarna');
  params.append('sessionId', sessionId);
  params.append('walletPaymentMethod', walletCode);

  const { resultType } = await fetchKlarnaSessionData(
    '/rpc.responsive.air.payment.updatewalletpaymentsession.do.action',
    params,
  );

  return resultType === 'OK';
};
